export class CheckBoxData {
  Id: number;
  Name: string;
  Checked: boolean;
  OriginalChecked: boolean;
  Group: number;
  GroupName: string;
  Order: number;
}
